unit Systematic.ObjectDictionary.Utils;

interface

uses Generics.Collections;

type
TObDictUtils<K,V> = class
private
  FObDict: TObjectDictionary<K, TList<V>>;
public
  constructor Create(aObDict: TObjectDictionary<K, TList<V>>);
  procedure Add(aId: K; aValue: V); overload;
  procedure AddRange(aId: K; aValue: TList<V>); overload;
  function CountAllItems: Integer;

  class procedure Add(aId: K; aValue: V; aDict: TObjectDictionary<K, TList<V>>); overload;
  class procedure AddRange(aId: K; aValue: TList<V>; aDict: TObjectDictionary<K, TList<V>>); overload;
end;

implementation

class procedure TObDictUtils<K,V>.Add(aId: K; aValue: V; aDict: TObjectDictionary<K, TList<V>>);
var
  aList: TList<V>;
begin
  if aDict.ContainsKey(aId) then
    aDict[aId].Add(aValue)
  else
  begin
    aList := TList<V>.Create;
    aList.Add(aValue);
    aDict.Add(aId, aList);
  end;
end;

class procedure TObDictUtils<K,V>.AddRange(aId: K; aValue: TList<V>; aDict: TObjectDictionary<K, TList<V>>);
var
  item: V;
begin
  for item in aValue do
    Add(aId, item, aDict);
end;

procedure TObDictUtils<K,V>.Add(aId: K; aValue: V);
begin
  Add(aId, aValue, FObDict);
end;

procedure TObDictUtils<K,V>.AddRange(aId: K; aValue: TList<V>);
begin
  AddRange(aId, aValue, FObDict);
end;

function TObDictUtils<K, V>.CountAllItems: Integer;
var
  value: TList<V>;
begin
  Result := 0;
  for value in FObDict.Values do
    Inc(Result, value.Count);
end;

constructor TObDictUtils<K,V>.Create(aObDict: TObjectDictionary<K, TList<V>>);
begin
  inherited Create;
  FObDict := aObDict;
end;

end.
